// eslint-disable-next-line import/prefer-default-export
export const getRedirectUrl = () => {
    const url = new URL(window.location.href);
    return `${url.origin}/upgrade/checkout`;
};
